module.exports = __webpack_public_path__ + "static/speed-client-66e8b3df6869fbebedfab04d87ad174f.png";